export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '0d29d9e', dateTime: 1780586890672 };